import { render } from "./TSMIndexCheck.vue?vue&type=template&id=a61521e0"
import script from "./TSMIndexCheck.vue?vue&type=script&lang=js"
export * from "./TSMIndexCheck.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__